<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  page: {
    title: '分類設定',
    meta: [{ name: 'description', content: 'Customer Analytics' }],
  },
  components: {},
  props: {
    // merchantProducts: {
    //   type: Array,
    //   required: true,
    // },
    // sellShow: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      activeTab: '1',
      // ifShow:false,
      tabList: [
        {
          title: '美容服務',
          component: () => import('@/src/router/views/prices/Category.vue'),
        }
      ],
      serviceCategory: [],
    }
  },
  computed: {
    activeIndex() {
      return parseInt(this.activeTab) - 1
    }
  },
  async mounted() {
    this.initModuleTab()
    this.activeTab = '1'
    this.serviceCategory = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
  },
  created() {
  },
  methods: {
    toClick() {
    },
    initModuleTab() {
      if (false) {
        this.tabList.push(
          {
            title: '基本設定',
            component: () => import('./components/TabMerchantCategoryBasic'),
          }
        )
        this.tabList.push(
          {
            title: '分類設定',
            component: () => import('./components/TabSecondCategory.vue'),
          }
        )
      }
    },
  },
}
</script>
    
<template>
  <div>
    <el-tabs ref="tab" v-model="activeTab" stretch class="is-no-border is-no-bg isStyleBaseLine isSecond"
      :class="$style.innerTabStyle" @tab-click="toClick">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
      </el-tab-pane>
    </el-tabs>
    <div :class="$style.categoryComponent">
      <component :is="tabList[activeIndex].component" :service-category="serviceCategory">
      </component>
    </div>
  </div>
</template>
<style lang="scss" module >
.innerTabStyle {
  :global {
    .el-tabs__header {
      margin-top: -15px;
      margin-bottom: 5px;
      padding-bottom: 1px;
      background-color: $color-body-bg;
      box-shadow: 0 3px 6px #dddfe0;
      margin-left: -15px;
      margin-right: -15px;
    }
  }
}

.categoryComponent {
  margin-left: 20px;
  margin-right: 20px;
}

:global {
  .is-second {
    .el-tabs__active-bar {
      // width: 80px !important;
      // transform: translateX(105.828px)!important;
      // margin-left:7%;
      // font-size: 16px;
    }

    .el-tabs__nav.is-stretch {
      // padding-left: 8%;
      // padding-right: 8%;
    }


    .el-tabs__item {
      font-size: 16px !important;

      &.is-active {
        color: $color-primary !important;
      }
    }
  }

  // .el-tabs--border-card .el-tabs__item:not([id=tab-byOrder]):not([id=tab-bySize]):after {
  //   background: none;
  // }
}
</style>
    